import React from 'react';
import { string } from 'prop-types';
import { Link } from 'react-router-dom';
import './styles.scss';

const IconCard = ({ description = '', icon, title, link }) => (
  <div className="icon-card">
    <div className="header-icon">
      <i className={`bi bi-${icon}`}></i>
    </div>
    <h3 className="header-title">{ title }</h3>
    <p className="card-description">
      { description }
    </p>
    <Link to={link}>Ver mas <i className="bi bi-chevron-right"></i></Link>
  </div>
);



IconCard.propTypes = {
  description: string,
  icon: string.isRequired,
  title: string.isRequired,
  link: string.isRequired,
};

IconCard.displayName = 'IconCard';

export default IconCard;
